// extracted by mini-css-extract-plugin
export default {"field_card":"FieldCard_field_card__0SIDz","info_icon":"FieldCard_info_icon__LXUTa"};